import React from 'react'
import {
    Box,
    Icon,
    Link as ExternalLink,
    SimpleGrid,
    Text,
    Flex,
    Heading,
    useColorModeValue,
    Divider,
    VStack, HStack,
} from '@chakra-ui/react'
import { EmailIcon, InfoIcon, PhoneIcon } from '@chakra-ui/icons'
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { Link } from 'gatsby'
import Logo from '../../uielements/Logo'
import { ContainerFull, ContainerXl } from '../../components/Containers/containers'
import { useTranslation } from 'react-i18next'
import EmailDisplayer from '../../components/EmailDisplayer'
import { MdSchool } from 'react-icons/md'
import { FaCloudSunRain } from "react-icons/fa6";

export default function LargeWithLogoCentered() {
    const { t } = useTranslation()

    return (
        <ContainerFull maxW={'container-full'} bg={useColorModeValue('gray.50', 'gray.900')}>
            <Box color={useColorModeValue('gray.700', 'gray.200')}>
                <ContainerXl>
                    <HStack flexDir={['column-reverse', 'column-reverse', 'column-reverse', 'row']} justifyContent={'space-between'} py={12}>
                        <VStack alignItems={['center', 'center', 'center', 'flex-start']}>
                            <Heading size={'xl'} my={2} textAlign={['center', 'center', 'center', 'left']}>
                                SOCIAL MEDIA
                            </Heading>
                            <HStack mt={8} p={2} justifyContent={['space-between', 'space-between', 'space-between', 'left']}>
                                <ExternalLink target={'_blank'} rel={'noreferrer'} href={'https://www.facebook.com/bougasedu'}>
                                    <Icon as={FaFacebook} boxSize={10} color="#3b5998" mx={8} />
                                </ExternalLink>
                                <ExternalLink target={'_blank'} rel={'noreferrer'} href={'https://www.instagram.com/bougas_school'}>
                                    <Icon as={FaInstagram} boxSize={10} color="#E1306C"  mx={8} />
                                </ExternalLink>
                                <ExternalLink target={'_blank'} rel={'noreferrer'} href={'https://www.linkedin.com/company/bougas-school'}>
                                    <Icon as={FaLinkedin} boxSize={10} color="#0077B5"  mx={8} />
                                </ExternalLink>
                            </HStack>
                        </VStack>
                        <VStack alignItems={['center', 'center', 'center', 'flex-end']}>
                            <Box p={1} mt={[2, 2, 2, 0]}>
                                <Link
                                    target={'_blank'}
                                    rel={'noreferrer'}
                                    to={'https://so.simple.edu.gr/Account/Login'}
                                >
                                    <Box
                                        display={'flex'}
                                        flexDir={'row'}
                                        alignItems={'center'}
                                    >
                                        <MdSchool size={'28px'} />
                                        <Text fontWeight={'bold'} fontSize={'xl'} mx={2}  textAlign={'right'}>ECLASS</Text>
                                    </Box>
                                </Link>
                            </Box>
                            <Box p={1} mb={[10, 10, 10, 0]}>
                                <Link
                                    target={'_blank'}
                                    rel={'noreferrer'}
                                    to={'https://penteli.meteo.gr/stations/kalamatawest/'}
                                >
                                    <Box
                                        display={'flex'}
                                        flexDir={'row'}
                                        alignItems={'center'}
                                    >
                                        <FaCloudSunRain size={'28px'} />
                                        <Text fontWeight={'bold'} fontSize={'xl'} mx={2} textTransform={'uppercase'} textAlign={'right'}>
                                            { t('meteo') }
                                        </Text>
                                    </Box>
                                </Link>
                            </Box>
                        </VStack>
                    </HStack>
                </ContainerXl>
                <Divider />
                <ContainerXl>
                    <Heading size={'xl'} my={2} textAlign={['center', 'center', 'center', 'left']}>
                        Contact Us
                    </Heading>
                    <SimpleGrid columns={[1,1,1,3]} mt={8} p={2}>
                        <VStack spacing="24px" m={[6, 4, 2, 0]} p={5}>
                            <EmailIcon boxSize={6} />
                            <EmailDisplayer originalReversedEmail={'rg.loohcs-saguob@me'} />
                        </VStack>
                        <VStack spacing="24px" m={[6, 4, 2, 0]} p={5}>
                            <PhoneIcon boxSize={6} />
                            <Text fontWeight={'bold'} fontSize={'md'}> +30 2721092022 & +30 2721092122</Text>
                        </VStack>
                        <VStack spacing="24px" m={[6, 4, 2, 0]} p={5}>
                            <InfoIcon boxSize={6} />
                            <Link target={'_blank'} rel={'noreferrer'} to={'https://bit.ly/bougas-school'}>
                                <Text fontWeight={'bold'} fontSize={'md'}>{t('contact.address')}</Text>
                            </Link>
                        </VStack>
                    </SimpleGrid>
                </ContainerXl>
                <Box py={2}>
                    <Flex
                        align={'center'}
                        _before={{
                            content: '""',
                            borderBottom: '1px solid',
                            borderColor: useColorModeValue('gray.200', 'gray.700'),
                            flexGrow: 1,
                            mr: 8,
                        }}
                        _after={{
                            content: '""',
                            borderBottom: '1px solid',
                            borderColor: useColorModeValue('gray.200', 'gray.700'),
                            flexGrow: 1,
                            ml: 8,
                        }}
                    >
                        <Logo width={'160px'} />
                    </Flex>
                    <Text pt={6} fontSize={'sm'} textAlign={'center'}>
                        Designed & Developed by <a target={'_blank'} rel="noreferrer" href="https://www.yorgo.dev">yorgo.dev</a>
                    </Text>
                    <Text pt={2} fontSize={'sm'} textAlign={'center'}>
                        Copyright © {new Date().getFullYear()}
                    </Text>
                </Box>
            </Box>
        </ContainerFull>
    )
}
